import { API } from "config/API"

export const getAllTaxes = async () => {
  const response = await API.get("/taxes/all")
  return response
}
